export { RoomCapacity } from './RoomCapacity';
